import type {
  FilterValue,
  NumberFilterRange,
  StringFilterRange,
} from '@warebee/shared/engine-model';

// -- FILTERS --
export enum FilterFieldDataType {
  String,
  NumberRange,
  IntegerRange,
  Date,
}

export enum FilterFieldEditorType {
  SingleSelect,
  SingleRadio,
  MultipleCheck,
  SliderRange,
  ABCRange,
  SliderRangeFixed,
  StringRange,
}

export type FilterFieldConfigCustomizable<T extends string> = {
  type: T;
  title: string;
  group?: string;
  disabled?: boolean;
  nullOptionTitle?: string;
};

export type FilterFieldConfigBase<T extends string> =
  FilterFieldConfigCustomizable<T> & {
    dataType?: FilterFieldDataType;
    editorType: FilterFieldEditorType;
    rangeMinValue?: number;
    rangeMaxValue?: number;
    isStatic?: boolean;
  };

// -- POLICY FILTERS ---
export type PolicyFilterBase<T extends string> = {
  type: T;
  valueIn?: FilterValue[];
  range?: NumberFilterRange;
  stringRange?: StringFilterRange;
  isNull?: boolean;
  isNot?: boolean;
};

export type PolicyFilterIntersection<T extends string> = {
  id?: string;
  allOf: PolicyFilterBase<T>[];
};

export type PolicyFilterUnion<T extends string> = {
  anyOf: PolicyFilterIntersection<T>[];
};

// -- FILTER PRESETS ---
export type FilterPresetDataType =
  | 'actualityHq'
  | 'actualityAssignment'
  | 'simulationHq';

export type FilterPreset<FT extends string> = {
  id: string;
  title: string;
  filterUnion: PolicyFilterUnion<FT>;
  isDynamic?: boolean;
};

export type FilterPresets<FT extends string> = FilterPreset<FT>[];

export type FilterPresetSelectedIdentity = {
  presetId: string;
  filterId?: string;
};
